module.exports = __webpack_public_path__ + "static/media/01C.478394d2.png";